import { JsonSafe } from './JsonSafe';

/**
 * Эмулирует интерфейс localStorage для работы в приватных вкладках
 * и других случаях, когда localStorage недоступно или выключено.
 */
class Fallback {
  _data: Record<string, string>;
  constructor() {
    this._data = Object.create(null);
  }

  getItem(key: string) {
    const data = this._data;

    if (key in data) {
      return data[key];
    }

    return null;
  }

  setItem(key: string, value: string) {
    if (arguments.length < 2) {
      throw new TypeError('2 arguments required');
    }

    this._data[key] = String(value);
  }

  removeItem(key: string) {
    delete this._data[key];
  }
}

/**
 * Позволяет работать с localStorage без необходимости
 * контролировать исключения и восстанавливать типы данных.
 */
export class ReflectStorage {
  _storage: Fallback | Storage;
  constructor() {
    try {
      // Может быть выключено в IE, переполнено
      // или недоступно в приватных вкладках.
      window.localStorage.setItem('reflectStorage', '1');
      window.localStorage.removeItem('reflectStorage');

      this._storage = window.localStorage;
    } catch (reason) {
      this._storage = new Fallback();
    }
  }

  getItem(key: string) {
    try {
      return this._storage.getItem(key);
    } catch (reason) {}

    return null;
  }

  setItem(key: string, value: string) {
    try {
      this._storage.setItem(key, value);
    } catch (reason) {}
  }

  removeItem(key: string) {
    try {
      this._storage.removeItem(key);
    } catch (reason) {}
  }

  get<T = Record<string, any>>(key: string) {
    return JsonSafe.parse<T>(this._storage.getItem(key));
  }

  set(key: string, value: any) {
    try {
      this._storage.setItem(key, JSON.stringify(value));
    } catch (reason) {}
  }

  remove(key: string) {
    this.removeItem(key);
  }
}
